export default function ProjectCard(props){
  return(
  <div className="project-card">
    <div className="text">
      <h3>{props.name}</h3>
      <h4> {props.lines}</h4>
      <p>{props.description}</p>
      <div className="proj-btn">
      <form action={props.github}>
<button type="submit" id="repo">Repo</button>
      </form>
      <form action={props.site}>
<button type="submit" id="site">Site</button>
      </form>
    </div>
    </div>
    <img src={props.img} alt="none" className="imgs"/>
  </div>
  )
}